import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Courier } from "./../_models/courier";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { CourierService } from "../_services/courier.service";
import { CountryService } from "../_services/country.service";

@Component({
  selector: "app-courier-list-page",
  templateUrl: "./courier-list-page.component.html",
  styleUrls: ["./courier-list-page.component.scss"],
})
export class CourierListPageComponent implements OnInit {
  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    public courierService: CourierService,
    public countryService: CountryService
  ) {}

  displayedColumns = ["Id", "Name", "CourierCode", "formatCountry", "formatActive"];
  dataSource: MatTableDataSource<Courier>;
  isDataLoaded = false;
  public countries: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Courier>();
    this.countryService.getCountries().subscribe(
      (countries) => {
        countries.forEach((country) => {
          this.countries[country.id] = country.name;
        });
      },
      (err) => {
        this.showErrorMessage("Error retrieving countries");
      }
    );
    this.courierService.getCouriers().subscribe(
      (couriers: Courier[]) => {
        this.dataSource.data = couriers.map((courier) => {
          courier.formatCountry = this.countries[courier.countryId];
          courier.formatActive = courier.active ? 'Active' : 'Inactive';
          return courier;
        });
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isDataLoaded = true;
      },
      (err) => {
        if (err.status == 404) {
          this.dataSource.data = [];
        }
        this.isDataLoaded = true;
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addCourier() {
    this.router.navigate(["regional", "courier", "add"]);
  }

  viewCourier(id: number) {
    this.router.navigate(["regional", "courier", id]);
  }
}
